import {get, post} from "@/utils/http";

let baseURL = "/contractApply";

// 分页查询合同申请记录
const getContractRecordPage = data => get(`${baseURL}/getContractRecordPage`, data);

// 提交合同申请
const applyInfo = data => post(`${baseURL}/applyContractInfo`, { data });

// 保存合同申请信息
const saveInfo = data => post(`${baseURL}/saveContractInfo`, { data });

// 审核通过
const approveApply = data => post(`${baseURL}/approveApply`,  { data });

// 审核拒绝
const rejectApply = data => post(`${baseURL}/rejectApply`, { data });

// 刪除申請
const deleteContractApply = data => post(`${baseURL}/deleteContractApply`, { data });

// contractApplyAPI
export default {
    getContractRecordPage,
    applyInfo,
    saveInfo,
    approveApply,
    rejectApply,
    deleteContractApply
};
